export default function formatDate(inputDate) {
    // Crea un oggetto Date a partire dalla stringa fornita
    const date = new Date(inputDate);
  
    // Estrae il giorno, il mese (ricorda che i mesi partono da 0) e l'anno
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
  
    // Restituisce la data formattata come "gg/mm/aaaa"
    return `${day}/${month}/${year}`;
  }